import { setUpClearButton } from '../services/search-service';
import { navigate } from '../services/window-location-service';
import { NakedFormSelect } from './naked-form-select';

class ArticlesSearchForm extends DrupalBehavior {
  onContent(context) {
    const search = once('search', 'input[name=keyword]', context);
    search.forEach(() => {
      setUpClearButton($(search));
      this.setUpHealthTopics(context);
      this.addActivePillsListeners(context);
    });
  }

  setUpHealthTopics(context) {
    new NakedFormSelect({
      formElement: context,
      target: 'select#edit-topic',
      placeholder: 'Search health topics',
      singleSelectOptions: {
        isSingleSelect: true,
      },
    }).setUpNakedFormSelectDropdown({
      headerText: 'Health Topics',
    });
  }

  addActivePillsListeners(context) {
    const newsUrl = window.location.origin + '/news';

    const buttons = once('pill-remove', '.pill-remove-button', context);
    buttons.forEach((button) => {
      button.addEventListener('click', function (e) {
        e.preventDefault();

        navigate(newsUrl);
      });
    });
  }
}

export default ArticlesSearchForm;

DrupalBehavior.register(
  'rush_theme.components',
  'articles_search_form',
  ArticlesSearchForm
);
